import { render, staticRenderFns } from "./acco_page.vue?vue&type=template&id=55794107&"
import script from "./acco_page.vue?vue&type=script&lang=js&"
export * from "./acco_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports